export const getComboName = (layers: Record<string, unknown> | undefined) => {
  if (!layers) return "";
  const combo = layers.combo;
  if (!combo) return "";
  const settings =
    typeof combo === "object" && "settings" in combo ? combo.settings : {};
  const name =
    settings && typeof settings === "object" && "name" in settings
      ? settings.name
      : "";
  return name;
};

export const getComboSettings = (
  layers: Record<string, unknown> | undefined,
) => {
  if (!layers) return {};
  const combo = layers.combo;
  if (!combo) return {};
  const settings =
    typeof combo === "object" && "settings" in combo ? combo.settings : {};
  return settings;
};
